<h1
  class="progress-stepper__title"
  [ngClass]="{ 'amend-padding': currentIndex !== 0 }"
>
  {{ title }}
</h1>
<div class="stepper-card">
  <ng-container *ngIf="!startPage; else startPageContent">
    <h5 class="progress-stepper__counter">
      Step {{ currentIndex + 1 }} of {{ progressStepsLength }}
    </h5>
  </ng-container>
  <ng-template #startPageContent>
    <h5 *ngIf="currentIndex" class="progress-stepper__counter">
      Step {{ currentIndex }} of {{ progressStepsLength - 1 }}
    </h5>
  </ng-template>

  <div
    *ngFor="
      let step of progressSteps$ | async;
      let i = index;
      trackBy: trackByStepIndex
    "
    class="progress-stepper__body"
  >
    <progress-stepper-item-smart-fix-hub
      [active]="i === currentIndex"
      [step]="step"
    >
      <ng-container *ngIf="i === progressStepsLength - 1">
        <div class="feedback-survey-wrapper">
          <feedback-smart-fix-hub class="feedback-survey" />
        </div>
        <redirect-to-mmr *ngIf="environment.hasMyAccountIntegration">
        </redirect-to-mmr>
      </ng-container>
    </progress-stepper-item-smart-fix-hub>
  </div>

  <div class="divider"></div>

  <div class="progress-stepper__buttons">
    <div>
      <ng-container *ngIf="currentIndex > 0">
        <div>
          <dgx-components-button-link
            variant="secondary"
            (click)="previous()"
            [iconName]="'arrow-left'"
            [iconAlign]="'left'"
          >
            Back
          </dgx-components-button-link>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="currentIndex < progressStepsLength - 1">
      <div>
        <dgx-components-button-link
          variant="primary"
          (click)="next()"
          [iconName]="'arrow-right'"
          [iconAlign]="'right'"
          data-testid="stepper-action-button"
        >
          {{
            currentIndex === 0 && startPage
              ? "Let's start"
              : currentIndex === progressStepsLength - 2
                ? 'Last step'
                : 'Next step'
          }}
        </dgx-components-button-link>
      </div>
    </ng-container>
  </div>
</div>
